import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { adminAuthAPI } from '../api';

export default function ForgotPassword() {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setSent(false);
    try {
      const { data } = await adminAuthAPI.forgotPassword({ email: email.trim() });
      if (data.success) setSent(true);
      else setError('No admin account found with that email.');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: '2rem', width: '100%', maxWidth: 400 }}>
        <h1 style={{ fontSize: '1.3rem', marginBottom: '0.5rem' }}>Reset Password</h1>
        <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Enter your admin email to generate a reset link.
        </p>

        {!sent ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            {error && <p style={{ color: '#ef4444', fontSize: '0.82rem', marginBottom: '0.75rem' }}>{error}</p>}
            <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        ) : (
          <div>
            <p style={{ color: '#22c55e', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Email sent!</p>
            <p style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
              Check <strong style={{ color: '#e2e8f0' }}>{email}</strong> for a password reset link. It expires in 30 minutes.
            </p>
          </div>
        )}

        <p style={{ marginTop: '1.25rem', fontSize: '0.82rem', color: '#64748b' }}>
          <Link to="/" style={{ color: '#60a5fa' }}>Back to login</Link>
        </p>
      </div>
    </div>
  );
}
